export default function getSearchIndices({ lang }) {
  if (lang && lang !== "") {
    return [
      {
        name: `${lang} resource hub data`,
        title: `${lang} resource hub data`,
        slug: `${lang} resource hub data`,
      },
    ];
  }

  return [
    {
      name: "resource hub data",
      title: "resource hub data",
      slug: "resource hub data",
    },
  ];
}
